import { useState, useEffect, useRef, useCallback } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Sparkles, Play, Volume2, VolumeX, Pause } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

// Direct video files - NO Instagram embeds
// thumbnailUrl will be generated from video frames at runtime
const galleryVideos = [
  {
    id: "video-1",
    mediaType: "video",
    videoUrl: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/bfu4l512_video-output-8E52B227-E8EC-4633-8DBC-D31EFD1D9A3A-1.mov",
    title: { no: "Brudestyling", en: "Bridal Styling" },
    category: "bridal",
    thumbnailTime: 1.5, // Extract frame at 1.5 seconds
  },
  {
    id: "video-2",
    mediaType: "video",
    videoUrl: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/868s533m_video-output-9651BAF0-622A-455C-BE65-A972E3BE9D0F.mov",
    title: { no: "Makeup Transformasjon", en: "Makeup Transformation" },
    category: "event",
    thumbnailTime: 1.5,
  },
  {
    id: "video-3",
    mediaType: "video",
    videoUrl: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/bdc9enxz_video-output-BCB33BCB-C971-405F-ADFF-1BBEE8095464-1.mov",
    title: { no: "Permanent Makeup", en: "Permanent Makeup" },
    category: "permanent",
    thumbnailTime: 1.5,
  },
  {
    id: "video-4",
    mediaType: "video",
    videoUrl: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/08t81fdr_video-output-CA32DD8D-83E0-4755-ABB7-571EA3AE86DF.mov",
    title: { no: "Skjønnhetsbehandling", en: "Beauty Treatment" },
    category: "brows",
    thumbnailTime: 1.5,
  },
  // New video added
  {
    id: "video-5",
    mediaType: "video",
    videoUrl: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/oeuc2hqa_instories_5F8BEEE9-D6FA-4162-AD93-95BFD5727559.mov",
    title: { no: "Permanent makeup", en: "Permanent makeup" },
    category: "permanent",
    thumbnailTime: 1.5,
  },
];

// Gallery images from uploaded assets
const galleryImages = [
  {
    id: "img-1",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_291695dd-746b-47c4-af20-bc1f9b2fc3ad/artifacts/blvhqg3z_05-bride.jpeg",
    title: { no: "Brud Makeup", en: "Bridal Makeup" },
    category: "bridal",
  },
  {
    id: "img-2",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_291695dd-746b-47c4-af20-bc1f9b2fc3ad/artifacts/xwe913hr_02-hairstyle.jpeg",
    title: { no: "Bryllupsoppsett", en: "Wedding Updo" },
    category: "bridal",
  },
  {
    id: "img-3",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_291695dd-746b-47c4-af20-bc1f9b2fc3ad/artifacts/lajluo3b_03-lips.jpeg",
    title: { no: "Permanent Makeup Lepper", en: "Permanent Lip Makeup" },
    category: "permanent",
  },
  {
    id: "img-4",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_291695dd-746b-47c4-af20-bc1f9b2fc3ad/artifacts/96boj0mc_04-makeup.jpeg",
    title: { no: "Fest Makeup", en: "Party Makeup" },
    category: "event",
  },
  {
    id: "img-5",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_291695dd-746b-47c4-af20-bc1f9b2fc3ad/artifacts/httlrxd0_01-brows.jpeg",
    title: { no: "Powder Brows", en: "Powder Brows" },
    category: "brows",
  },
  // New images added
  {
    id: "img-6",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/xnxp1gpm_6BAC5B07-2DC9-4988-8ABE-CB8043680321.jpeg",
    title: { no: "Brudestyling", en: "Bridal Styling" },
    category: "bridal",
  },
  {
    id: "img-7",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/1a7njrlp_9A5CBD75-E233-4A02-B3C8-5519D3E7B550.jpeg",
    title: { no: "Brud Makeup og Hår", en: "Bridal Makeup and Hair" },
    category: "bridal",
  },
  {
    id: "img-8",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/5tkjezki_CC78FE0D-EE79-4D1A-8E34-C3F11640F576.jpeg",
    title: { no: "Powder Brows Behandling", en: "Powder Brows Treatment" },
    category: "brows",
  },
  {
    id: "img-9",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/dsvmflq2_IMG_0339.jpeg",
    title: { no: "Glam Styling", en: "Glam Styling" },
    category: "event",
  },
  {
    id: "img-10",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/zgg915bb_IMG_1993.jpeg",
    title: { no: "Øyebryn Detalj", en: "Eyebrow Detail" },
    category: "brows",
  },
  // New images added - batch 2
  {
    id: "img-11",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/wwthiaq8_B96EC50A-539D-4610-80F3-BB710DC966C6.jpeg",
    title: { no: "Permanent makeup", en: "Permanent makeup" },
    category: "permanent",
  },
  {
    id: "img-12",
    mediaType: "image",
    url: "https://customer-assets.emergentagent.com/job_141dc66c-4a99-4f53-829b-56669273ddfe/artifacts/q0k9x2bq_D6BA1862-6122-4354-91E0-3177412817A6.jpeg",
    title: { no: "Permanent makeup", en: "Permanent makeup" },
    category: "permanent",
  },
];

// Combine and interleave photos and videos for natural mix
const createGalleryItems = () => {
  const items = [];
  const images = [...galleryImages];
  const videos = [...galleryVideos];
  
  let imgIndex = 0;
  let vidIndex = 0;
  
  // Interleave: 2 images, 1 video pattern
  while (imgIndex < images.length || vidIndex < videos.length) {
    if (imgIndex < images.length) {
      items.push(images[imgIndex++]);
    }
    if (imgIndex < images.length) {
      items.push(images[imgIndex++]);
    }
    if (vidIndex < videos.length) {
      items.push(videos[vidIndex++]);
    }
  }
  
  return items;
};

const galleryItems = createGalleryItems();

// Video Thumbnail Component - uses video element to show first frame
function VideoThumbnail({ item, onClick, language, getCategoryName }) {
  // Use the item's actual title
  const title = item.title[language] || item.title.no;
  const videoRef = useRef(null);
  const [thumbnailReady, setThumbnailReady] = useState(false);
  
  // When video loads metadata, seek to thumbnail time to show that frame
  const handleLoadedMetadata = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.currentTime = Math.min(item.thumbnailTime || 1.5, videoRef.current.duration - 0.1);
    }
  }, [item.thumbnailTime]);

  const handleSeeked = useCallback(() => {
    setThumbnailReady(true);
  }, []);

  return (
    <div
      className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-lg shadow-[#D4A5A5]/10 hover:shadow-xl hover:shadow-[#D4A5A5]/20 transition-all duration-300"
      onClick={onClick}
      data-testid={`gallery-video-${item.id}`}
    >
      {/* Video element showing frame at thumbnailTime */}
      <div className="w-full aspect-[4/5] bg-[#F9F5F6] relative overflow-hidden">
        <video
          ref={videoRef}
          src={item.videoUrl}
          className={`w-full h-full object-cover transition-opacity duration-300 ${thumbnailReady ? 'opacity-100' : 'opacity-0'}`}
          muted
          playsInline
          preload="metadata"
          onLoadedMetadata={handleLoadedMetadata}
          onSeeked={handleSeeked}
        />
        {/* Loading state */}
        {!thumbnailReady && (
          <div className="absolute inset-0 flex items-center justify-center bg-[#F9F5F6]">
            <div className="w-8 h-8 border-3 border-[#D4A5A5]/30 border-t-[#D4A5A5] rounded-full animate-spin" />
          </div>
        )}
      </div>
      
      {/* Play Icon Overlay */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-white/90 backdrop-blur-sm flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
          <Play size={28} className="text-[#D4A5A5] ml-1" fill="#D4A5A5" />
        </div>
      </div>
      
      {/* Video Badge */}
      <div className="absolute top-3 right-3 px-2.5 py-1 rounded-full bg-black/60 backdrop-blur-sm flex items-center gap-1.5">
        <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
        <span className="text-white text-xs font-medium">Video</span>
      </div>
      
      {/* Fixed Title Overlay - "Brudestyling" for all videos */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent pointer-events-none">
        <div className="absolute bottom-0 left-0 right-0 p-4 sm:p-5">
          <h3 className="font-['Playfair_Display'] text-white text-base sm:text-lg font-semibold mb-0.5 drop-shadow-lg">
            {title}
          </h3>
          <p className="text-white/90 text-xs sm:text-sm font-medium drop-shadow-md">
            {getCategoryName(item.category)}
          </p>
        </div>
      </div>
    </div>
  );
}

// Image Thumbnail Component
function ImageThumbnail({ item, onClick, language, getCategoryName }) {
  const title = item.title[language] || item.title.no;
  
  return (
    <div
      className="relative group cursor-pointer overflow-hidden rounded-2xl shadow-lg shadow-[#D4A5A5]/10 hover:shadow-xl hover:shadow-[#D4A5A5]/20 transition-all duration-300"
      onClick={onClick}
      data-testid={`gallery-image-${item.id}`}
    >
      <img
        src={item.url}
        alt={title}
        className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
        loading="lazy"
      />
      {/* Hover Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-[#4A4A4A]/80 via-[#4A4A4A]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
        <div className="absolute bottom-0 left-0 right-0 p-5">
          <h3 className="font-['Playfair_Display'] text-white text-lg font-semibold mb-1">
            {title}
          </h3>
          <span className="text-white/80 text-sm">
            {getCategoryName(item.category)}
          </span>
        </div>
      </div>
    </div>
  );
}

// Native Video Lightbox - plays video with sound
function VideoLightbox({ item, onClose, language, getCategoryName }) {
  // Use the item's actual title
  const title = item.title[language] || item.title.no;
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMuted, setIsMuted] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  
  // Prevent body scroll when lightbox is open
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);

  // Auto-play when loaded
  const handleLoadedData = useCallback(() => {
    setIsLoading(false);
    if (videoRef.current) {
      videoRef.current.play().catch(console.error);
      setIsPlaying(true);
    }
  }, []);

  const togglePlay = useCallback(() => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  }, [isPlaying]);

  const toggleMute = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  }, [isMuted]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/95"
      onClick={onClose}
      data-testid="video-lightbox"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ type: "spring", damping: 25 }}
        className="relative w-full max-w-3xl"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 z-10 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-colors"
          data-testid="close-video-lightbox-btn"
          aria-label="Close"
        >
          <X size={20} />
        </button>

        {/* Video Container */}
        <div className="relative rounded-2xl overflow-hidden bg-black">
          {/* Loading State */}
          {isLoading && (
            <div className="absolute inset-0 flex items-center justify-center bg-black z-10">
              <div className="w-12 h-12 border-4 border-[#D4A5A5]/30 border-t-[#D4A5A5] rounded-full animate-spin" />
            </div>
          )}
          
          {/* Native Video Player */}
          <video
            ref={videoRef}
            src={item.videoUrl}
            className="w-full max-h-[75vh] object-contain"
            playsInline
            onLoadedData={handleLoadedData}
            onPlay={() => setIsPlaying(true)}
            onPause={() => setIsPlaying(false)}
            onEnded={() => setIsPlaying(false)}
            onClick={togglePlay}
          />
          
          {/* Video Controls Overlay */}
          <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/80 to-transparent">
            <div className="flex items-center justify-between mb-2">
              <div>
                <h3 className="font-['Playfair_Display'] text-white text-lg font-semibold">
                  {title}
                </h3>
                <span className="text-white/70 text-sm">
                  {getCategoryName(item.category)}
                </span>
              </div>
              <div className="flex items-center gap-2">
                {/* Play/Pause Button */}
                <button
                  onClick={togglePlay}
                  className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-colors"
                  aria-label={isPlaying ? "Pause" : "Play"}
                >
                  {isPlaying ? <Pause size={18} /> : <Play size={18} className="ml-0.5" />}
                </button>
                {/* Mute Button */}
                <button
                  onClick={toggleMute}
                  className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-colors"
                  aria-label={isMuted ? "Unmute" : "Mute"}
                >
                  {isMuted ? <VolumeX size={18} /> : <Volume2 size={18} />}
                </button>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}

// Image Lightbox Component
function ImageLightbox({ item, onClose, language, getCategoryName }) {
  const title = item.title[language] || item.title.no;
  
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, []);
  
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/90"
      onClick={onClose}
      data-testid="gallery-lightbox"
    >
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        transition={{ type: "spring", damping: 25 }}
        className="relative max-w-5xl w-full max-h-[90vh]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute -top-12 right-0 sm:top-4 sm:right-4 z-10 w-10 h-10 rounded-full bg-white/20 backdrop-blur-sm flex items-center justify-center text-white hover:bg-white/30 transition-colors"
          data-testid="close-lightbox-btn"
          aria-label="Close"
        >
          <X size={20} />
        </button>

        {/* Image */}
        <div className="relative rounded-2xl overflow-hidden bg-[#1a1a1a]">
          <img
            src={item.url}
            alt={title}
            className="w-full max-h-[80vh] object-contain"
          />
          
          {/* Image Info */}
          <div className="absolute bottom-0 left-0 right-0 p-6 bg-gradient-to-t from-black/80 to-transparent">
            <h3 className="font-['Playfair_Display'] text-white text-xl sm:text-2xl font-semibold mb-1">
              {title}
            </h3>
            <span className="text-white/70 text-sm">
              {getCategoryName(item.category)}
            </span>
          </div>
        </div>
      </motion.div>
    </motion.div>
  );
}

export default function GalleryPage() {
  const { language, t } = useLanguage();
  const [activeCategory, setActiveCategory] = useState("all");
  const [selectedItem, setSelectedItem] = useState(null);

  // Categories with bilingual support
  const categories = [
    { id: "all", name: t("gallery.categories.all") },
    { id: "bridal", name: t("gallery.categories.bridal") },
    { id: "event", name: t("gallery.categories.event") },
    { id: "permanent", name: t("gallery.categories.permanent") },
    { id: "brows", name: t("gallery.categories.brows") },
  ];

  const filteredItems =
    activeCategory === "all"
      ? galleryItems
      : galleryItems.filter((item) => item.category === activeCategory);

  const getCategoryName = (categoryId) => {
    const cat = categories.find((c) => c.id === categoryId);
    return cat ? cat.name : categoryId;
  };

  return (
    <div className="pt-20 bg-[#FDFBFB] min-h-screen" data-testid="gallery-page">
      {/* Hero Section */}
      <section className="relative py-16 sm:py-24 bg-gradient-to-b from-[#F9F5F6] to-[#FDFBFB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center max-w-3xl mx-auto"
          >
            <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/80 text-[#D4A5A5] text-sm font-medium mb-6 shadow-sm">
              <Sparkles size={16} />
              {language === "en" ? "Our Work" : "Vårt arbeid"}
            </span>
            <h1 className="font-['Playfair_Display'] text-4xl sm:text-5xl lg:text-6xl font-bold text-[#4A4A4A] mb-6">
              {t("gallery.title")}
            </h1>
            <p className="text-[#8C8C8C] text-base sm:text-lg max-w-2xl mx-auto">
              {t("gallery.subtitle")}
            </p>
          </motion.div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="sticky top-20 z-40 bg-white/95 backdrop-blur-md border-b border-[#F2E8E8] shadow-sm">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-2 sm:gap-3 py-4 overflow-x-auto scrollbar-hide">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                data-testid={`gallery-category-${category.id}`}
                className={`px-4 py-2.5 rounded-full text-xs sm:text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                  activeCategory === category.id
                    ? "bg-[#D4A5A5] text-white shadow-md"
                    : "bg-[#F9F5F6] text-[#4A4A4A] hover:bg-[#F2E8E8]"
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Masonry Gallery Grid */}
      <section className="py-12 sm:py-16">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          {filteredItems.length > 0 ? (
            <div className="columns-1 sm:columns-2 lg:columns-3 gap-4 sm:gap-6">
              {filteredItems.map((item, index) => (
                <motion.div
                  key={item.id}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: index * 0.1 }}
                  className="break-inside-avoid mb-4 sm:mb-6"
                >
                  {item.mediaType === "video" ? (
                    <VideoThumbnail
                      item={item}
                      onClick={() => setSelectedItem(item)}
                      language={language}
                      getCategoryName={getCategoryName}
                    />
                  ) : (
                    <ImageThumbnail
                      item={item}
                      onClick={() => setSelectedItem(item)}
                      language={language}
                      getCategoryName={getCategoryName}
                    />
                  )}
                </motion.div>
              ))}
            </div>
          ) : (
            <div className="text-center py-16">
              <p className="text-[#8C8C8C]">{t("gallery.noImages")}</p>
            </div>
          )}
        </div>
      </section>

      {/* Lightbox Modal */}
      <AnimatePresence>
        {selectedItem && (
          selectedItem.mediaType === "video" ? (
            <VideoLightbox
              item={selectedItem}
              onClose={() => setSelectedItem(null)}
              language={language}
              getCategoryName={getCategoryName}
            />
          ) : (
            <ImageLightbox
              item={selectedItem}
              onClose={() => setSelectedItem(null)}
              language={language}
              getCategoryName={getCategoryName}
            />
          )
        )}
      </AnimatePresence>
    </div>
  );
}
